module.exports = __webpack_public_path__ + "static/media/share_icon_black.65864ad1.svg";